import React from 'react';
import { InfoIcon, TargetIcon } from 'lucide-react';
export function LeagueScores() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3372">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3373">
        <div className="mb-16" data-id="element-3374">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3375">
            Sporting Clays League Scores
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3376">
            {/* Info note */}
            <div className="flex items-start gap-3 p-4 rounded-lg mb-6" style={{
            backgroundColor: 'rgba(200,168,75,0.08)',
            border: '1px solid rgba(200,168,75,0.2)'
          }} data-id="element-3377">
              <InfoIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#c8a84b'
            }} data-id="element-3378" />
              <p className="text-sm leading-relaxed" style={{
              color: '#2a2a2a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3379">
                Weeks 9 and 10 are for makeup scores only. League consists of 8
                scores posted over a 10 week total period.
              </p>
            </div>

            {/* Placeholder for scores */}
            <div className="flex flex-col items-center justify-center py-12 rounded-lg" style={{
            backgroundColor: '#f8f6f0',
            border: '2px dashed #d6d0c4'
          }} data-id="element-3380">
              <TargetIcon size={36} style={{
              color: '#c8a84b'
            }} data-id="element-3381" />
              <p className="mt-3 text-base font-medium" style={{
              color: '#4a6a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3382">
                League scores will be posted here as they become available.
              </p>
              <p className="mt-1 text-sm" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3383">
                Check back during the active league season.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}